import { wrapRootElementC } from "./src/lib/RQuery";
import React from "react";
import CookieConsestBox from "./src/common/components/cookieConsestBox.js/cookieConsestBox";
import { createRoot } from "react-dom/client";
import { PermissionsProvider } from "./src/common/context/PermissionsContext";
// import { navigate } from "gatsby";

export const wrapRootElement = wrapRootElementC;

export const wrapPageElement = ({ element }) => (
  <PermissionsProvider>{element}</PermissionsProvider>
);

// const MAINTENANCE_PATH = "/maintenance";
// export const onRouteUpdate = ({ location }) => {
//   if (!location.pathname.startsWith(MAINTENANCE_PATH)) {
//     navigate(MAINTENANCE_PATH, { replace: true });
//   }
// };

export const onClientEntry = () => {
  !navigator.cookieEnabled &&
    createRoot(
      document.getElementById(
        "ThisIsToInjectCookieBoxIdWhichExistInAppWrapperTC",
      ),
    ).render(<CookieConsestBox language={"ar"} />);
  if (!localStorage?.getItem("gatsby-i18next-language")) {
    // Set the default language to Arabic (ar)
    localStorage?.setItem("gatsby-i18next-language", "ar");
  }
};
